import React from "react";
import "./orderTable.css";

const OrderTable = ({orderDetails}) => {

  
  return (
   
    <table className="order-table table">
      <thead className="order-table-head">
        <tr>
          <th>Item Name</th>
          <th>Special Note</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Total</th>
        </tr>
      </thead>

      <tbody className="order-table-body">

        {orderDetails?.order_items?.length > 0 &&  (
          orderDetails?.order_items?.map ((item)=> (
<tr key={item.order_item_id}>
          <td>{item.order_item_name}</td>
          <td>--</td>
          <td>{item.order_item_quantity}</td>
          <td>{item.order_item_price}</td>
          <td>{(Number(item.order_item_price) * Number(item.order_item_quantity))}</td>
        </tr>
        ))
        )}
        

 

        {/* Summary Rows */}
        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>{`CGST (${orderDetails.tax?.[0]?.order_tax_price}%)`}</td>
          <td>{orderDetails.tax?.[0]?.restaurant_liable_amount}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>{`SGST (${orderDetails.tax?.[1]?.order_tax_price}%)`}</td>
          <td>{orderDetails.tax?.[1]?.restaurant_liable_amount}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>Packing Charges</td>
          <td>{orderDetails?.packing_charges}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>Discount</td>
          <td>{orderDetails?.order_discount_price}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>Delivery Charges</td>
          <td>{orderDetails?.delivery_charges}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>Delivery Charges Tax Amount</td>
          <td>{orderDetails?.dc_tax_amount}</td>
        </tr>

        <tr className="summary-row">
          <td colSpan="3"></td>
          <td>Packing Charges Tax Amount</td>
          <td>{orderDetails?.pc_tax_amount}</td>
        </tr>

        {/* Grand Total */}
        <tr className="grand-total-row">
          <td colSpan="3"></td>
          <td>Grand Total</td>
          <td>{orderDetails?.total}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default OrderTable;
